import React from "react";
import { Field, ErrorMessage } from "formik";
import { FaCalendarAlt } from "react-icons/fa";
import FormField from "../components/FormField";
import Rules from "../components/Rules";
import InfoTooltip from "../components/InfoTooltip";

export const Step4 = ({ colors, values, isInvited = false }) => (
  <div
    className="space-y-6 p-6 rounded-lg"
    style={{ backgroundColor: colors.background }}
  >
    <h3
      className="text-2xl font-semibold border-b pb-2"
      style={{ borderColor: colors.border }}
    >
      Confirmation
    </h3>

    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <label className="flex items-center">
          <Field
            name="reglementInterieurLu"
            type="checkbox"
            className="rounded"
            style={{
              accentColor: colors.primary,
              borderColor: colors.border,
            }}
          />
          <span className="ml-2" style={{ color: colors.text }}>
            Le règlement intérieur et Lu et approuvé.{" "}
            <span style={{ color: colors.secondary }}>*</span>
          </span>
        </label>
        <div className="flex items-center gap-5">
          <Rules />
          <InfoTooltip
            title="Information importante !"
            text="Merci de lire le règlement. Il contient les règles à suivre pour garantir une bonne ambiance au sein de notre communauté. Votre adhésion implique le respect de ces règles"
          />
        </div>
      </div>
      <ErrorMessage
        name="reglementInterieurLu"
        component="div"
        className="mt-1 text-sm"
        style={{ color: colors.secondary }}
      />

      <FormField
        name="dateSignature"
        label="Date de signature"
        icon={FaCalendarAlt}
        type="date"
        required
      />
    </div>

    <div className="mt-8">
      <div className="w-[80%] m-auto h-[1px] rounded-full bg-white mb-5" />
      <h4 className="text-lg font-semibold mb-4" style={{ color: colors.text }}>
        Récapitulatif de vos informations :
      </h4>
      <ul
        className="list-disc list-inside space-y-2"
        style={{ color: colors.text }}
      >
        <li>Nom : {values.nom}</li>
        <li>Prénom : {values.prenom}</li>
        <li>Pseudo : {values.pseudo}</li>
        <li>Email : {values.email}</li>
        <li>Téléphone : {values.telephone}</li>
        <li>Domaine(s) de pratique : {values.domainePratique.join(", ")}</li>
        {!isInvited && <li>Statut : {values.statut}</li>}
        {!isInvited && <li>Mode de paiement : {values.modePaiement}</li>}
      </ul>
    </div>
  </div>
);
